module.exports = __webpack_public_path__ + "img/coupon_zhTc.396bde7c.png";